import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const FlagDayIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fill='currentColor'
                d='M1.44688 7.27493C1.3063 6.75028 1.6248 6.20909 2.15826 6.06615C2.69173 5.9232 3.23815 6.23264 3.37873 6.75729L7.19687 21.0068C7.33745 21.5314 7.01895 22.0726 6.48548 22.2155C5.95202 22.3585 5.40559 22.0491 5.26501 21.5244L1.44688 7.27493Z'
            />
            <Path
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                d='M5.77756 6.07699C7.17767 5.17171 8.86265 4.81461 10.4995 5.06754L10.8257 5.12672C12.7631 5.52458 14.7803 5.25254 16.5431 4.36513L16.8918 4.17971L18.044 3.53329L19.8593 10.308L18.2098 11.2342C16.9281 11.9534 15.4304 12.1841 14.0029 11.8903L13.7185 11.825C11.4525 11.2432 9.04247 11.6792 7.12254 13.002L5.3424 6.35838L5.77756 6.07699Z'
            />
        </>
    ),
})

FlagDayIcon.displayName = 'FlagDayIcon'
